export const DELETE_CONFLICT_MODAL_CLOSE = "deleteConflictModal/close";

export const closeDeleteConflictModal = () => ({
  type: DELETE_CONFLICT_MODAL_CLOSE
});
